import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../../assets/styles/tokens";

type StatusColor = "success" | "warning" | "error";

interface BLDWebsiteUserCardProps {
  date: string;
  Spent: string;
  cpc: string;
  clickOut: string;
  ClickIn: string;
  ftdBR: string;
  ftdNG: string;
  ftdPercentage: string;
  ftdColor: StatusColor;
  cvrPercentage: string;
  cvrColor: StatusColor;
  qftd: string;
}

export function BLDWebsiteUserCard({
  date,
  Spent,
  cpc,
  clickOut,
  ClickIn,
  ftdBR,
  ftdNG,
  ftdPercentage,
  ftdColor,
  cvrPercentage,
  cvrColor,
  qftd,
}: BLDWebsiteUserCardProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              m: 0,
            }}
          >
            {date}
          </Typography>
        </Stack>

        <Stack
          sx={{ mb: spacing.Spacing.xs.$value, mt: spacing.Spacing.xs.$value }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {Spent}
            </Box>
            Spent at
            <Box
              component="span"
              sx={{ fontWeight: typography.Font_weight.Medium.$value, mx: 0.5 }}
            >
              {cpc}
            </Box>
            CPC
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: spacing.Spacing.xxs.$value }}
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              Click Out/In
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mx: 1,
              }}
            >
              {clickOut} / {ClickIn}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: spacing.Spacing["9xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: 1,
              }}
            >
              CVR
            </Typography>
            <Chip
              label={cvrPercentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                bgcolor:
                  cvrColor === "success"
                    ? colors.Success[50].$value
                    : cvrColor === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  cvrColor === "success"
                    ? colors.Success[600].$value
                    : cvrColor === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              FTD’S BR/NG
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mx: 0.5,
              }}
            >
              {ftdBR} / {ftdNG}
            </Typography>
            <Chip
              label={ftdPercentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                bgcolor:
                  ftdColor === "success"
                    ? colors.Success[50].$value
                    : ftdColor === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  ftdColor === "success"
                    ? colors.Success[600].$value
                    : ftdColor === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: spacing.Spacing["9xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: 1,
              }}
            >
              QFTD
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                mr: 1,
              }}
            >
              {qftd}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default BLDWebsiteUserCard;
